export default __webpack_public_path__ + "static/media/placeholder_business01-es-web.599e59bd.png";